// extracted by mini-css-extract-plugin
var _1 = "Container-q8Awj";
var _2 = "Title-SyG62";
export { _1 as "Container", _2 as "Title" }
